import DashboardLayout from '../layout/DashboardLayout';

const DashboardRouting: React.FC = () => {
  return <DashboardLayout />;
};

export default DashboardRouting;
